/*
 * Which AppDraggable lists have a drag running. Sortable ends the running drag without an `end` event when any of its lists is
 * destroyed during it, the list the drag started from or another one (a remote change removes it, or the page navigates away). Whoever
 * keeps state for the duration of a drag can learn here that it is over.
 */
// Each drag's owner, with what it has to undo when the drag ends without an end event: its autoscroll and listeners.
const owners = new Map<object, () => void>();
const abandonedListeners = new Set<() => void>();
// Sortable's class, with the drag it is running as `active`. Taken from a mounted list: it is not a direct dependency of the app.
let sortableClass: { active: unknown } | null = null;

export const noteSortableClass = (value: { active: unknown } | null | undefined) => {
    if (value) sortableClass = value;
};

export const dragStarted = (owner: object, cleanup: () => void) => {
    owners.set(owner, cleanup);
};

export const dragEnded = (owner: object) => {
    owners.delete(owner);
};

/** Called after a list was destroyed. */
export const dragListDestroyed = () => {
    if (owners.size === 0 || !sortableClass || sortableClass.active) return;
    const cleanups = [...owners.values()];
    owners.clear();
    cleanups.forEach((cleanup) => cleanup());
    // In fallback mode Sortable leaves the dragged clone in the page when the drag ends this way.
    document.querySelectorAll('.sortable-fallback').forEach((element) => element.remove());
    abandonedListeners.forEach((listener) => listener());
};

export const isDragInProgress = () => owners.size > 0;

/** Returns the function that stops listening. */
export const onDragAbandoned = (listener: () => void) => {
    abandonedListeners.add(listener);
    return () => abandonedListeners.delete(listener);
};
